import React, { lazy } from "react";
import styles from "./Opportunities.module.scss";
import Container from "../Container/Container";
import GradientText from "../GradientText/GradientText";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";

// const { Swiper, SwiperSlide } = lazy(() => import("swiper/react"));

const Opportunities = () => {
    const matches2 = useMediaQuery("(min-width: 750px)");
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <Container>
                <div className={styles.body}>
                    {matches2 ? (
                        <>
                            <div className={styles.col}>
                                <div className={styles.order}>01</div>
                                <div className={styles.info}>
                                    <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                                    <p>
                                        {t("landing.opportunities.p1")}
                                        {/* способен действовать самостоятельно, без вмешательства людей. Он может придумывать торговые
                                        стратегии, тестировать и дорабатывать их, а также учитывает рыночные тренды, чтобы
                                        совершенствоваться с помощью свеже обретённых знаний. То есть искусственный интеллект умеет
                                        имитировать мышление аналитиков. */}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.col}>
                                <div className={styles.order}>02</div>
                                <div className={styles.info}>
                                    <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                                    <p>
                                        {t("landing.opportunities.p2")}
                                        {/* способен обрабатывать бесчисленное количество данных за считаные минуты. Таким же образом находить и
                                        анализировать исторические данные и повторяющиеся модели для ведения «умной» торговли, которые часто
                                        скрыты, недоступны людям. */}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.col}>
                                <div className={styles.order}>03</div>
                                <div className={styles.info}>
                                    <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                                    <p>
                                        {t("landing.opportunities.p3")}
                                        {/* работает на любых рыночных условиях, без эмоций 24/7 на основе алгоритмов машинного обучения и
                                        нейронных сетей. */}
                                    </p>
                                </div>
                            </div>
                        </>
                    ) : (
                        <></>
                        // <Swiper slidesPerView={1.4} spaceBetween={10} grabCursor={true}>
                        //     <SwiperSlide className={styles.slide}>
                        //         <div className={styles.col}>
                        //             <div className={styles.order}>01</div>
                        //             <div className={styles.info}>
                        //                 <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                        //                 <p>{t("landing.opportunities.p1")}</p>
                        //             </div>
                        //         </div>
                        //     </SwiperSlide>
                        //     <SwiperSlide className={styles.slide}>
                        //         <div className={styles.col}>
                        //             <div className={styles.order}>02</div>
                        //             <div className={styles.info}>
                        //                 <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                        //                 <p>{t("landing.opportunities.p2")}</p>
                        //             </div>
                        //         </div>
                        //     </SwiperSlide>
                        //     <SwiperSlide className={styles.slide}>
                        //         <div className={styles.col}>
                        //             <div className={styles.order}>03</div>
                        //             <div className={styles.info}>
                        //                 <GradientText small={true} underlineText={"p2p"} text="Sairus" />
                        //                 <p>{t("landing.opportunities.p3")}</p>
                        //             </div>
                        //         </div>
                        //     </SwiperSlide>
                        // </Swiper>
                    )}
                </div>
            </Container>
        </div>
    );
};

export default Opportunities;
